var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "areaBox",
      style: {
        width: _vm.areaInit.areaWidth + "px",
        height: _vm.areaInit.areaHeight + "px",
        left: _vm.areaInit.starX + "px",
        top: _vm.areaInit.starY + "px",
      },
      on: {
        mousedown: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "left", 37, $event.key, [
              "Left",
              "ArrowLeft",
            ])
          ) {
            return null
          }
          if ("button" in $event && $event.button !== 0) {
            return null
          }
          $event.stopPropagation()
          return _vm.mouseDownLint($event)
        },
        mouseup: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "left", 37, $event.key, [
              "Left",
              "ArrowLeft",
            ])
          ) {
            return null
          }
          if ("button" in $event && $event.button !== 0) {
            return null
          }
          $event.stopPropagation()
          return _vm.mouseUp($event)
        },
        dblclick: function ($event) {
          _vm.editBoxShow = true
        },
      },
    },
    [
      _c("div", { staticClass: "prompt-text" }, [
        _c("div", { staticClass: "prompt-item num" }, [
          _vm._v(_vm._s(_vm.areaInit.name)),
        ]),
        _c(
          "div",
          {
            staticClass: "prompt-item",
            style: { color: _vm.isSet ? "#2d8cf0" : "#f00" },
          },
          [_vm._v(" " + _vm._s(_vm.isSet ? "(已设置)" : "(未设置)") + " ")]
        ),
      ]),
      _c(
        "div",
        {
          staticClass: "del",
          on: {
            click: function ($event) {
              $event.stopPropagation()
              return _vm.del()
            },
          },
        },
        [_c("i", { staticClass: "el-icon-close" })]
      ),
      _c("div", {
        staticClass: "shape",
        on: {
          mousedown: function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "left", 37, $event.key, [
                "Left",
                "ArrowLeft",
              ])
            ) {
              return null
            }
            if ("button" in $event && $event.button !== 0) {
              return null
            }
            $event.stopPropagation()
            return _vm.shapeDown($event)
          },
          mouseup: function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "left", 37, $event.key, [
                "Left",
                "ArrowLeft",
              ])
            ) {
              return null
            }
            if ("button" in $event && $event.button !== 0) {
              return null
            }
            $event.stopPropagation()
            return _vm.mouseUp($event)
          },
        },
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "设置热区",
            visible: _vm.editBoxShow,
            width: "540px",
            "append-to-body": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.editBoxShow = $event
            },
          },
        },
        [
          _c(
            "el-form",
            [
              _c("el-form-item", { attrs: { label: "热区跳转链接:" } }, [
                _c(
                  "div",
                  { on: { click: _vm.getLink } },
                  [
                    _c(
                      "el-input",
                      {
                        attrs: { readonly: "" },
                        model: {
                          value: _vm.link,
                          callback: function ($$v) {
                            _vm.link = $$v
                          },
                          expression: "link",
                        },
                      },
                      [
                        _c("i", {
                          staticClass: "iconfont iconlianjietubiao",
                          attrs: { slot: "suffix" },
                          slot: "suffix",
                        }),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.editBoxShow = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.editBoxShow = false
                    },
                  },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("linkaddress", { ref: "linkaddres", on: { linkUrl: _vm.linkUrl } }),
      _c("img", {
        staticClass: "right-bottom",
        attrs: { src: require("@/assets/imgs/rightBottom.png"), alt: "" },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }